import * as React from "react";
import {cx} from "emotion";

import "./address-distance.scss";

import {bindInput} from "@Common/react/bind-input";
import {cs}        from "@Common/react/chain-services";
import {isNumber}  from "@Common/react/cs-form-2/validators/is-number";
import {max}       from "@Common/react/cs-form-2/validators/max";
import {min}       from "@Common/react/cs-form-2/validators/min";
import {required}  from "@Common/react/cs-form-2/validators/required";

import {AddressForm}     from "../common/address-form/address-form";
import {getErrorMessage} from "../common/get-error-message";

export const AddressDistance = ({showErrors, onSearch, query}) => cs(
    ["addressForm", (_, next) => AddressForm({
        line1: {
            path: "distance",
            validators: [
                required,
                isNumber,
                min(1),
                max(10),
            ],
            label: "Distance",
            control: (field) => (
                <div className="input-4ed">
                    <div className="input">
                        <input {...{
                            className: cx({hasError: field.error}),
                            placeholder: "Miles",
                            ...bindInput(field.state),
                            "xd-qa-type": "text_field",
                            "xd-qa-name": "Demographics Search Distance",
                        }}/>
                    </div>
                    {field.error && (
                        <div className="error" xd-qa-type="label" xd-qa-name="Demographics Search Distance Error">
                            {getErrorMessage(field.error)}
                        </div>
                    )}
                </div>
            ),
        },
        query,
        next,
    })],
    ({addressForm}) => (
        <div className="address-distance-1v8">
            {addressForm.render({
                showErrors,
                onSearch,
            })}
        </div>
    ),
);
